import React from 'react';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#020617] pt-24 pb-16" data-testid="terms-of-service-page">
      <div className="max-w-4xl mx-auto px-6">
        {/* Back link */}
        <a 
          href="/"
          className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft size={18} />
          Back to Home
        </a>

        {/* Content */}
        <div className="prose prose-invert prose-slate max-w-none">
          <h1 className="text-4xl md:text-5xl font-semibold text-white mb-4">Terms of Service</h1>
          <p className="text-slate-400 text-lg mb-12">
            <strong>Effective Date:</strong> March 11, 2026
          </p>

          <p className="text-slate-300 leading-relaxed mb-8">
            Welcome to the website of <strong>Timoleon Therapeutics Limited</strong>. These terms and conditions outline the rules and regulations for the use of our website.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">1. Intellectual Property Rights</h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            Unless otherwise stated, Timoleon Therapeutics Limited and/or its licensors own the intellectual property rights for all material on this website, including but not limited to our proprietary AI-enabled structural prediction concepts and molecular designs. All intellectual property rights are reserved.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">2. Restrictions</h2>
          <p className="text-slate-300 leading-relaxed mb-4">
            You are specifically restricted from all of the following:
          </p>
          <ul className="list-disc list-inside text-slate-300 space-y-2 mb-8 ml-4">
            <li>Publishing any website material in any other media without prior consent.</li>
            <li>Selling, sublicensing, or otherwise commercializing any website material.</li>
            <li>Using this website in any way that is or may be damaging to this website.</li>
            <li>Using this website to engage in any data mining, data harvesting, or data extracting.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">3. No Medical or Investment Advice</h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            The information on this website is provided for informational purposes only regarding our research and development platform. It does not constitute medical advice, nor does it constitute an offer to sell or a solicitation of an offer to buy any securities.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">4. Limitation of Liability</h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            In no event shall Timoleon Therapeutics Limited, nor any of its officers, directors, and employees, be held liable for anything arising out of or in any way connected with your use of this website.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">5. Governing Law & Jurisdiction</h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            These Terms will be governed by and interpreted in accordance with the laws of <strong>England and Wales</strong>, and you submit to the non-exclusive jurisdiction of the courts located in England for the resolution of any disputes.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">6. Registered Office</h2>
          <div className="text-slate-300 leading-relaxed">
            <p className="font-semibold text-white">Timoleon Therapeutics Limited</p>
            <p>71-75 Shelton Street, Covent Garden</p>
            <p>London, United Kingdom, WC2H 9JQ</p>
            <p className="mt-2">Company Number: 17067450</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
